export default "__VITE_ASSET__DptH0yxa__"